import { ProductVariationDtoMap } from '@libs/mtjr/shared/generated/dtoMaps/product-variation.dto.map';
import { Enums } from '@libs/mtjr/shared/generated/types';
import { Expose, Type } from 'class-transformer';

export class ProductUpdateDtoMap {
  @Expose()
  size?: Enums.ProductSize;

  @Expose()
  name?: string;

  @Expose()
  description?: string;

  @Expose()
  images?: string[];

  @Expose()
  price?: number;

  @Expose()
  discount?: number;

  @Expose()
  stock?: number;

  @Type(() => ProductVariationDtoMap)
  @Expose()
  variations?: ProductVariationDtoMap[];

  @Expose()
  bgColor?: string;
}
